import { put, select } from 'redux-saga/effects';

import PropertyActions from './PropertyRedux';
import { AppSelectors } from './AppRedux';

import logger from '@utils/logger';
import API from '@utils/api';

import { transformPropertyApiResponse } from '@services/transform';

export function* fetchProperty(actions) {
  const { propertyId } = actions;
  yield put(PropertyActions.setPropertyLoading(true));

  try {
    const { result } = yield API.fetchProperty(propertyId);
    const { basicInfo, serviceInfo } = transformPropertyApiResponse(result);
    const { result: propertySettings } = yield API.fetchPropertySettings(
      propertyId
    );

    yield put(PropertyActions.setPropertyId(propertyId));
    yield put(PropertyActions.setPropertyBasicInfo(basicInfo));
    yield put(PropertyActions.setPropertyMoreInfo(serviceInfo));
    yield put(PropertyActions.setPropertySettings(propertySettings));
  } catch (err) {
    logger.error('err: ', err);
  }
  yield put(PropertyActions.setPropertyLoading(false));
}

export function* updateLocalProperty(actions) {
  const { apiProperty, currentData } = actions;

  yield put(PropertyActions.setPropertyLoading(true));

  const offices = yield select(AppSelectors.selectOffices);
  const regions = yield select(AppSelectors.selectRegions);

  try {
    const { basicInfo, serviceInfo } = transformPropertyApiResponse(
      apiProperty,
      currentData,
      offices,
      regions
    );

    yield put(PropertyActions.setPropertyBasicInfo(basicInfo));
    yield put(PropertyActions.setPropertyMoreInfo(serviceInfo));
  } catch (err) {
    logger.error('err: ', err);
  }
  yield put(PropertyActions.setPropertyLoading(false));
}
